<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('editCalculateDot.txt1')}}</span>
        <span>{{$t('editCalculateDot.txt2')}} / {{$t('editCalculateDot.txt3')}}/{{addDotForm.id?$t('editCalculateDot.txt7'):$t('editCalculateDot.txt8')}}</span>
      </div>
      <div class="flexEnd">
        <div class="searchBtn ml20" @click="onBack">{{$t('editCalculateDot.txt6')}}</div>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{addDotForm.id?$t('editCalculateDot.txt4'):$t('editCalculateDot.txt5')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('editCalculateDot.txt9')}}</div>
          <div class="searchBtn" @click="submitAddDotForm('addDotForm')">{{$t('editCalculateDot.txt10')}}</div>
        </div>
      </div>
      <div class="editForm editWidth">
        <el-form :model="addDotForm" :rules="addDomRules" ref="addDotForm" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="$t('editCalculateDot.txt11')" prop="calculationName">
          <el-input :placeholder="$t('editCalculateDot.txt12')" @blur="checkCalculationName(addDotForm.calculationName)" v-model="addDotForm.calculationName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('editCalculateDot.txt13')" prop="lanIp">
          <el-input :placeholder="$t('editCalculateDot.txt14')" v-model="addDotForm.lanIp"></el-input>
        </el-form-item>
        <el-form-item :label="$t('editCalculateDot.txt15')" prop="calculationDescribe">
          <el-input type="textarea" v-model="addDotForm.calculationDescribe" :placeholder="$t('editCalculateDot.txt16')" maxlength="100" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      </div>
    </el-card>

    
  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        addDotForm:{},//添加用户参数
        // 添加计算节点
        addDomRules: {
          calculationName: [
            { required: true, message: this.$t('editCalculateDot.txt12'), trigger: 'blur' },
          ],
          lanIp:[
            { required: true, message: this.$t('editCalculateDot.txt18'), trigger: 'blur' },
            { pattern: /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/, message: this.$t('editCalculateDot.txt19') },
          ],
        },
      };
    },
    created() {
      this.addDotForm.id = this.$route.query.id?this.$route.query.id:'';
      if(this.addDotForm.id){
        this.getCalculationInfo();
      }
    },

    methods: {
      onBack(){
        this.$router.go(-1);
      },
      // 新增编辑计算节点
      submitAddDotForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.add();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 计算节点详细
      async getCalculationInfo() {
        let data = {
          calculationId: this.addDotForm.id
        }
        const {
          data: res
        } = await this.$http.post("/calculation/getCalculationInfo?"+qs.stringify(data));
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.addDotForm = res.result;
      },
      // 按名字查
      async checkCalculationName(calculationName){
        let data = {
          calculationName
        }
        const {
          data: res
        } = await this.$http.post("/calculation/find/name?"+qs.stringify(data));
        if (!res.success) {
          return this.$message.error(res.message);
        } 
      },
      // 添加计算节点
      async add() {
        let data = {
          id:this.addDotForm.id,
          calculationName:this.addDotForm.calculationName,
          lanIp:this.addDotForm.lanIp,
          calculationDescribe:this.addDotForm.calculationDescribe,
          online:true,
          state: 1
        }
        const {data: res} = await this.$http.post("/calculation/add",data);
        if(res.success){
          this.$message({
            message: res.message,
            type: 'success'
          });
          this.$router.go(-1);
        }else{
          return this.$message.error(res.message);
        }
      },
    },
  };
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .userPage{
    /deep/ .el-upload__input{
      display: none !important;
    }
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .w350{
      width: 350px;
    }
    .searchUserBox{
      /*width: 33.6rem !important;*/
      height: 3.2rem;
      margin-bottom: 3rem;
      /deep/ .el-input__inner{
        border:1px solid #C0C0C0;
        border-right:none;
      }
      /deep/ .el-input-group__append{
        border:1px solid #C0C0C0;
        border-left:none;
        padding:0;
        background: #fff;
      }
      /deep/ .el-input-group__append button.el-button{
        padding:0;
        width: auto;
        margin-right: 1.1rem;
      }
    }
    /deep/ .el-transfer__button:first-of-type{
      display: none;
    }
    /deep/ .el-button--primary{
      width: auto;
      height: auto;
      padding:0;
      background: none;
    }
    /deep/ .el-button--primary.is-disabled{
      background: none;
      border: none;
    }
    /deep/ .el-transfer-panel{ 
      border: 1px solid #C0C0C0;
      border-radius: 6px;
      width: 46%;
      margin-right: 0.8rem;
    }
    /deep/ .el-transfer-panel:last-of-type{
      margin-left: 0.8rem;
      margin-right: 0rem;
    }
    /deep/ .el-transfer-panel .el-transfer-panel__header{
      background: #EEEEEE; 
      font-size: 1.4rem;
      font-weight: bold;
      color: #1B3B7C;
    }
    /deep/ .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label{
      font-size: 1.4rem;
      font-weight: bold;
      color: #1B3B7C;
    }
    /deep/ .el-button+.el-button{
      margin-left: 0 !important;
    }
    /deep/ .el-transfer__buttons{
      padding:0;
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    .editForm{}
    /deep/  .el-date-table td.today span{
      color: #fff;
      background: #1B3B7C;
      border-radius: 100%;
    }
    /deep/ .el-date-table td.end-date span,/deep/ .el-date-table td.start-date span{
      background: #1B3B7C !important;
    }

  }

</style>
